import React from "react";
import { ScrollArea } from "@shadcn-in-nx/ui/scroll-area";
import { useTranslation } from "react-i18next";

function ModalTechnicalTab({ execution, executionDetails }) {
    const { t } = useTranslation();

    return (
        <ScrollArea className="h-full pr-6">
            <div className="space-y-6">
                <div>
                    <h3 className="font-medium text-sm text-gray-500 mb-2">
                        {t("monitoring.modal.executionId")}
                    </h3>
                    <p className="font-mono text-sm bg-gray-100 px-3 py-2 rounded border">
                        {execution.id}
                    </p>
                </div>
                {executionDetails?.data && (
                    <div className="space-y-4">
                        {executionDetails.data.contextData && (
                            <div>
                                <h4 className="font-medium text-base mb-3">
                                    {t("monitoring.modal.rawContextData")}
                                </h4>
                                <div className="bg-gray-50 border rounded-lg p-4 max-h-64 overflow-auto">
                                    <pre className="text-xs font-mono">
                                        {JSON.stringify(executionDetails.data.contextData, null, 2)}
                                    </pre>
                                </div>
                            </div>
                        )}
                        {executionDetails.data.logs && (
                            <div>
                                <h4 className="font-medium text-base mb-3">
                                    {t("monitoring.modal.rawLogData")}
                                </h4>
                                <div className="bg-gray-50 border rounded-lg p-4 max-h-64 overflow-auto">
                                    <pre className="text-xs font-mono">
                                        {JSON.stringify(executionDetails.data.logs, null, 2)}
                                    </pre>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </ScrollArea>
    );
}

export default ModalTechnicalTab;
